import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import App from './App';

import * as UserStateActions from './reducers/UserReducer';

function mapStateToProps(state) {
	return {
		loggedIn: state.user.loggedIn,
		authLoading: state.user.authLoading,
		auth: state.user.auth,

		emailVerified: state.user.emailVerified,

		profileLoading: state.user.profileLoading,

		user: state.user.user,
		uid: state.user.uid,

		admin: state.user.admin,

		notifications: state.user.notifications,

		snackStatus: state.user.snackStatus,
		snackMessage: state.user.snackMessage
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(UserStateActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/AppContainer.js